<div class="widget">
  <iframe *ngIf="w && url" class="iframe" [src]="url" width="100%" ></iframe>
</div>
